export const normalizeNotificationCity = (value: unknown): string => (
    typeof value === 'string' && value.trim().length <= 120 ? value.trim() : ''
);

/** Intersect with the API's eligible results; a push never grants shift access. */
export const filterJobsForNotification = <T extends { location?: { city?: string } }>(jobs: T[], city: string): T[] => {
    const normalized = normalizeNotificationCity(city).toLocaleLowerCase();
    return normalized ? jobs.filter(job => job.location?.city?.trim().toLocaleLowerCase() === normalized) : jobs;
};
